import { Input } from '../ui/input';
import { Label } from '../ui/label';

export interface CustomGroupFormFieldsProps {
  name: string;
  description: string;
  address: string;
  onNameChange: (value: string) => void;
  onDescriptionChange: (value: string) => void;
  onAddressChange: (value: string) => void;
  nameError?: string;
  disabled?: boolean;
}

export function CustomGroupFormFields({
  name,
  description,
  address,
  onNameChange,
  onDescriptionChange,
  onAddressChange,
  nameError,
  disabled = false,
}: CustomGroupFormFieldsProps) {
  return (
    <div className='space-y-4'>
      <div className='space-y-2'>
        <Label htmlFor='custom-group-name'>
          Group Name <span className='text-destructive'>*</span>
        </Label>
        <Input
          id='custom-group-name'
          value={name}
          onChange={(e) => onNameChange(e.target.value)}
          placeholder='Enter group name'
          disabled={disabled}
          aria-invalid={!!nameError}
          aria-describedby={nameError ? 'custom-group-name-error' : undefined}
        />
        {nameError && (
          <p id='custom-group-name-error' className='text-sm text-destructive'>
            {nameError}
          </p>
        )}
      </div>

      <div className='space-y-2'>
        <Label htmlFor='custom-group-description'>Description</Label>
        <textarea
          id='custom-group-description'
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          placeholder='Optional description'
          disabled={disabled}
          rows={3}
          className='flex w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50'
        />
      </div>

      <div className='space-y-2'>
        <Label htmlFor='custom-group-address'>Address</Label>
        <Input
          id='custom-group-address'
          value={address}
          onChange={(e) => onAddressChange(e.target.value)}
          placeholder='Optional address'
          disabled={disabled}
        />
      </div>
    </div>
  );
}
